import React, { Fragment } from 'react';
import Progressbar from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListButton from '@material-ui/core/ListItemSecondaryAction';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import normalizeMobile from '../../../fns/normalizeMobile';

const ListAddresses = ({ addresses, onClick, onDelete, onEdit }) => {
  const handleClick = (id) => onClick(id);
  return (
    <Fragment>
      {addresses != null ? (
        <List>
          {addresses?.length ? (
            addresses.map((a) => (
              <ListItem key={a._id} button onClick={() => handleClick(a)}>
                <ListItemText
                  primary={a.details}
                  secondary={`${a?.transferee ? a.transferee : null}${
                    a?.mobilePhone
                      ? ' - ' + normalizeMobile(a.mobilePhone)
                      : null
                  }${
                    a?.companyNationalCode
                      ? ` - ${a.companyNationalCode}`
                      : a?.nationalCode
                      ? ` - ${a.nationalCode}`
                      : ''
                  }${a?.zipcode ? ` - ${a.zipcode}` : ''}`}
                />
                <ListButton>
                  <IconButton onClick={() => onDelete(a._id)}>
                    <DeleteIcon />
                  </IconButton>
                </ListButton>
              </ListItem>
            ))
          ) : (
            <div>آدرسی تاکنون برای این کاربر ذخیره نشده است.</div>
          )}
        </List>
      ) : (
        <Progressbar />
      )}
    </Fragment>
  );
};

export default React.memo(ListAddresses);
